import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgExternalLink = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M16.028 0a1.259 1.259 0 1 0 0 2.517h3.674L8.425 13.795a1.259 1.259 0 1 0 1.78 1.78L21.483 4.298v3.674a1.259 1.259 0 0 0 2.517 0V1.264m0-.005c0-.025 0-.05-.002-.075a1.254 1.254 0 0 0-.779-1.09A1.254 1.254 0 0 0 22.741 0h-6.713M1.155 5.183a3.944 3.944 0 0 1 2.79-1.155h6.712a1.259 1.259 0 1 1 0 2.517H3.944a1.427 1.427 0 0 0-1.427 1.427v12.084a1.426 1.426 0 0 0 1.427 1.427h12.084a1.427 1.427 0 0 0 1.427-1.427v-6.713a1.259 1.259 0 1 1 2.517 0v6.713A3.944 3.944 0 0 1 16.028 24H3.944A3.944 3.944 0 0 1 0 20.056V7.972c0-1.046.416-2.05 1.155-2.789Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgExternalLink);
export default ForwardRef;
